/* GMapBuilder -- builds the Google Maps */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {

  var GMap = function () {

    var ICON_SIZES = [8, 12, 16, 20, 24, 28, 32, 36, 40];
    var ICON_SIZE_NULL_MAGNITUDE = 6;
    var MARKER_FIXED_SIZE = 20;
    var MARKER_COLORS = [
      '5e4fa2e6',
      '3288bde6',
      '66c2a5e6',
      'abdda4e6',
      'fee08be6',
      'fdae61e6',
      'f46d43e6',
      'd53e4fe6',
      '9e0142e6'
    ];
    var MARKER_COLOR_NULL = 'C7C8CAe6';
    var LARGE_STATION_ZOOM_THRESHOLD = 7;
    var MAP_TYPE_COOKIE = "map_type";
    var MARKER_TYPE_COOKIE = "event_marker_type";
    var MARKER_MULTIPLIER_COOKIE = "event_marker_multiplier";
    var RADIUS_COLORS = ['#FF0000'];
    var CIRCLE_SHAPE = 0;
    var SQUARE_SHAPE = 1;
    // Event z-index uses epoch time so we need to set the facility z-index close to the max to get those icons on top
    var FACILITY_Z_INDEX = 2000000000;

    var module = {};

    module.MARKER_FLAG_AUTOMATIC = "@";
    module.MARKER_TYPES = {
      DATE: "date",
      MAGNITUDE: "magnitude",
      DEPTH: "depth",
      DATE_FIXED: "date_fixed"
    };
    module.MARKER_MULTIPLIER_DEFAULT = 1;

    var stations = [];
    var eventMarkerData = [];
    var eventMarkers = {};
    var stationMarkersLabelled = {};
    var stationMarkersUnlabelled = {};
    var facilityMarkerData = [];
    var facilityMarkers = {};
    var map;
    var stationMarkerManager;
    var mapBounds;
    var infoWindow;
    var lines = [];
    var eventLinesId = null;
    var markerType = module.MARKER_TYPES.DATE;
    var hasNullMagnitudes = false;
    var hasNullDepths = false;
    var hasExternalEvents = false;
    var markerMultiplier = module.MARKER_MULTIPLIER_DEFAULT;
    var eventRadii = [];
    var eventRadiusColors = RADIUS_COLORS;
    var magnitudeRange = {};
    var timeRange = {};
    var depthRange = {};
    var singleEventWithMatchingStations = false;
    var showStationInfo = true;

    // only used by b-value page (main page map ported to Angular)
    module.setupMapMultipleEvents = function (options) {
      // stations, eventMarkerData, elementId, mapType, viewType, bounds,
      // showMapTypeControl, markerType, magnitudeRange, eventRadii, eventRadiusColors
      stations = options.stations;
      eventMarkerData = options.eventMarkerData;
      facilityMarkerData = options.facilityMarkerData;
      showStationInfo = false;

      setupMap(options);

      if (MapCookies.hasShowStationsSelected()) {
        setupStations(showStationInfo);
      }
      var eventBounds = setupEvents();

      if (eventMarkerData.length > 0) {
        var legendDiv = document.createElement("div");
        new LegendControl(legendDiv);
        map.controls[google.maps.ControlPosition.RIGHT].push(legendDiv);
      }

      if(options.showFacilityIcons){
        setupFacilities(false);
      }

      if (options.viewType == "bounding_box") {
        mapBounds = eventBounds;
        map.fitBounds(mapBounds);
      }
      else if (options.viewType == "specific_region") {
        setBounds(options.bounds);
      }
    };

    module.setupMapStations = function (options) {
      stations = options.stations;
      setupMap(options);
      mapBounds = setupStations(true);
      map.fitBounds(mapBounds);
    };

    module.showStation = function (id) {
      var stationId = "station_" + id;
      if (infoWindow.contentId == stationId) {
        infoWindow.close();
        infoWindow.contentId = null;
      }
      else {
        var marker = getStationMarker(id);

        // Station Map URL: /stations/:id/info
        // Single Event Map URL: /events/:id/station_info?station_id=:id
        var locale = I18n.locale;
        var stationUrl = "/" + locale + "/stations/" + id + "/info";
        if (typeof(eventMarkerData) !== 'undefined' && eventMarkerData.length == 1) {
          stationUrl = "/" + locale + "/events/" + eventMarkerData[0].id + "/station_info?station_id=" + id;
        }
        $("#station_info").load(stationUrl, function () {
          showInfoWindow(stationId, marker, document.getElementById("station_info_" + id));
        });
      }
    };

    module.showFacility = function (id) {
      var facilityId = "facility_" + id;
      if (infoWindow.contentId == facilityId) {
        infoWindow.close();
        infoWindow.facilityId = null;
      }
      else {
        var marker = facilityMarkers[id];
        var locale = I18n.locale;
        var facilityInfoUrl = "/" + locale + "/facilities/" + id + "/info";
        $("#facility_info").load(facilityInfoUrl, function () {
          infoWindow.facilityId = facilityId;
          infoWindow.setContent(document.getElementById("facility_info_" + id).cloneNode(true));
          infoWindow.open(map, marker);
        });
      }
    };

    module.map = function () {
      return map;
    };

    module.stationMarkersUnlabelled = function () {
      return stationMarkersUnlabelled;
    };

    module.getEventMarkerType = function () {
      return markerType;
    };

    module.setEventMarkerType = function (newMarkerType) {
      var allowedMarkerTypes = Object.keys(module.MARKER_TYPES).map(function (key) {
        return module.MARKER_TYPES[key];
      }).concat(module.MARKER_FLAG_AUTOMATIC);
      if (allowedMarkerTypes.indexOf(newMarkerType) < 0) {
        throw new Error("Invalid event marker type: " + newMarkerType);
      }
      if (newMarkerType != markerType) {
        Cookies.set(MARKER_TYPE_COOKIE, newMarkerType);
        window.location.reload();
      }
    };

    module.setEventMarkerMultiplier = function (multiplier) {
      if (multiplier == "" || isNaN(multiplier) || multiplier < 0.1 || multiplier > 1) {
        throw new Error("Invalid event marker multiplier, must be a number between 0 and 1");
      }
      Cookies.set(MARKER_MULTIPLIER_COOKIE, multiplier);
    };

    module.getEventMarkerMultiplier = function () {
      return markerMultiplier;
    };

    function setBounds(bounds) {
      mapBounds = new google.maps.LatLngBounds();
      mapBounds.extend(new google.maps.LatLng(bounds.lower.latitude, bounds.lower.longitude));
      mapBounds.extend(new google.maps.LatLng(bounds.upper.latitude, bounds.upper.longitude));
      map.fitBounds(mapBounds);
    }

    function translateMapTypeToName(mapType) {
      if (mapType == google.maps.MapTypeId.HYBRID) {
        return "hybrid";
      }
      else if (mapType == google.maps.MapTypeId.SATELLITE) {
        return "satellite";
      }
      else if (mapType == google.maps.MapTypeId.TERRAIN) {
        return "terrain";
      }
      return "map";
    }

    function translateNameToMapType(name) {
      if (name == "hybrid") {
        return google.maps.MapTypeId.HYBRID;
      }
      else if (name == "satellite") {
        return google.maps.MapTypeId.SATELLITE;
      }
      else if (name == "terrain") {
        return google.maps.MapTypeId.TERRAIN;
      }
      return google.maps.MapTypeId.ROADMAP;
    }

    function setupMap(options) {
      // elementId, mapType, showMapTypeControl, markerType, eventRadii, eventRadiusColors
      magnitudeRange = options.magnitudeRange;
      timeRange = options.timeRange;
      depthRange = options.depthRange;
      if (options.markerType) {
        markerType = options.markerType;
      }
      if (options.eventRadii) {
        eventRadii = options.eventRadii;
      }
      if (options.eventRadiusColors && options.eventRadiusColors.length > 0) {
        eventRadiusColors = options.eventRadiusColors;
      }
      var markerMultiplierFromCookie = Cookies.get(MARKER_MULTIPLIER_COOKIE);
      if (markerMultiplierFromCookie) {
        markerMultiplier = markerMultiplierFromCookie;
      }
      var mapOptions = {};
      var name = Cookies.get(MAP_TYPE_COOKIE);
      if (name) {
        mapOptions.mapTypeId = translateNameToMapType(name);
      }
      else {
        if (typeof options.mapType == "undefined") {
          options.mapType = "hybrid";
        }
        mapOptions.mapTypeId = translateNameToMapType(options.mapType);
      }
      mapOptions.center = new google.maps.LatLng(37.4419, -122.1419);
      mapOptions.zoom = 2;
      mapOptions.minZoom = 1;
      mapOptions.scaleControl = true;
      mapOptions.mapTypeControl = options.showMapTypeControl;
      mapOptions.streetViewControl = false;
      mapOptions.panControl = false;
      mapOptions.zoomControlOptions = {position: google.maps.ControlPosition.LEFT_BOTTOM};
      mapOptions.fullscreenControlOptions = {position: google.maps.ControlPosition.RIGHT_BOTTOM},
        map = new google.maps.Map(document.getElementById(options.elementId), mapOptions);

      google.maps.event.addListener(map, "maptypeid_changed", function () {
        var newName = translateMapTypeToName(map.getMapTypeId());
        if (newName != options.mapType) {
          Cookies.set(MAP_TYPE_COOKIE, newName);
        }
      });

      if (showStationInfo) {
        infoWindow = new google.maps.InfoWindow();
        google.maps.event.addListener(infoWindow, "closeclick", function () {
          infoWindow.contentId = null;
        });
      }
    }

    function getStrippedMarkerType() {
      return markerType.replace(module.MARKER_FLAG_AUTOMATIC, "");
    }

    function generateEpicenterMarkerImage(eventMarker, color, size) {
      var shape = eventMarker.is_external ? SQUARE_SHAPE : CIRCLE_SHAPE;
      return GMapUtil.generateMarkerImage(epicenterUrl(color, size, shape), size);
    }

    function generateBeachballMarkerImage(eventMarker, color, size) {
      var imageUrl = beachballUrl(eventMarker.strike, eventMarker.dip, eventMarker.rake, size, color);
      return GMapUtil.generateMarkerImage(imageUrl, size)
    }

    function adjustSizeWithMultiplier(startingSize) {
      return Math.round(markerMultiplier * startingSize);
    }

    function adjustedNullSize() {
      return adjustSizeWithMultiplier(ICON_SIZE_NULL_MAGNITUDE);
    }

    function adjustedFixedSize() {
      return adjustSizeWithMultiplier(MARKER_FIXED_SIZE);
    }

    function adjustedCircleSize() {
      return adjustSizeWithMultiplier(MAGNITUDE_CIRCLE_SIZE);
    }

    function makeRoundShape(size) {
      var dr = (size / 2) - ((size / 2) * 0.707);
      return {
        coord: [dr, dr, size / 2, 0, size - dr, dr, size, size / 2, size - dr, size - dr, size / 2, size, dr, size - dr,
          0, size / 2],
        type: 'poly'
      };
    }

    function setupEvents() {
      var eventBounds = new google.maps.LatLngBounds();
      var indexCounter = eventMarkerData.length;
      for (var i = 0; i < eventMarkerData.length; i++) {
        var coord = new google.maps.LatLng(eventMarkerData[i].latitude, eventMarkerData[i].longitude);
        var markerImage;
        var markerShape;
        var colorIndex;
        var color;
        var strippedMarkerType = getStrippedMarkerType();
        if (strippedMarkerType == module.MARKER_TYPES.DATE) {
          color = MARKER_COLORS[timeToIndex(eventMarkerData[i].time)];
        }
        else if (strippedMarkerType == module.MARKER_TYPES.DEPTH) {
          if (eventMarkerData[i].depth) {
            color = MARKER_COLORS[depthToIndex(eventMarkerData[i].depth)];
          }
          else {
            color = MARKER_COLOR_NULL;
            hasNullDepths = true;
          }
        }
        if (strippedMarkerType == module.MARKER_TYPES.DATE || strippedMarkerType == module.MARKER_TYPES.DEPTH) {
          var size = adjustSizeWithMultiplier(ICON_SIZES[magnitudeToIndex(eventMarkerData[i].magnitude)]);
          if (eventMarkerData[i].strike != null) {
            markerImage = generateBeachballMarkerImage(eventMarkerData[i], color, size);
          }
          else if (eventMarkerData[i].magnitude != null) {
            markerImage = generateEpicenterMarkerImage(eventMarkerData[i], color, size);
            markerShape = makeRoundShape(size);
          }
          else {
            var nullSize = adjustedNullSize();
            hasNullMagnitudes = true;
            markerImage = generateEpicenterMarkerImage(eventMarkerData[i], color, nullSize);
            markerShape = makeRoundShape(nullSize);
          }
        }
        else {
          var fixedSize = adjustedFixedSize();
          colorIndex = strippedMarkerType == module.MARKER_TYPES.MAGNITUDE ? magnitudeToIndex(eventMarkerData[i].magnitude) : colorIndex = timeToIndex(eventMarkerData[i].time);
          color = MARKER_COLORS[colorIndex];
          if (eventMarkerData[i].strike != null) {
            markerImage = generateBeachballMarkerImage(eventMarkerData[i], color, fixedSize);
          }
          else if (strippedMarkerType == module.MARKER_TYPES.DATE_FIXED || eventMarkerData[i].magnitude != null) {
            markerImage = generateEpicenterMarkerImage(eventMarkerData[i], color, fixedSize);
          }
          else {
            hasNullMagnitudes = true;
            markerImage = generateEpicenterMarkerImage(eventMarkerData[i], MARKER_COLOR_NULL, fixedSize);
          }
          markerShape = makeRoundShape(fixedSize);
        }
        var markerZIndex = --indexCounter;
        if (eventMarkerData[i].strike) {
          markerZIndex += eventMarkerData.length
        }
        var markerOptions =
          {
            map: map,
            position: coord,
            zIndex: markerZIndex,
            icon: markerImage,
            shape: markerShape,
            title: eventMarkerData[i].title,
            clickable: false
          };
        addEventMarker(markerOptions, eventMarkerData[i]);
        if (eventRadii.length > 0) {
          addEventCircle(eventMarkerData[i], coord);
        }
        eventBounds.extend(coord);

        if (eventMarkerData[i].is_external) {
          hasExternalEvents = true;
        }

        //A single event means the bounding box only has one point which causes GMap
        //to zoom in too far.  Add another point to the box to create a wider range
        //and zoome out a little. See Bug 11737
        if (eventMarkerData.length == 1) {
          //LatLng handles lats>+-90 and longs >+-180
          coord = new google.maps.LatLng(eventMarkerData[0].latitude + 10, eventMarkerData[0].longitude + 10);
          eventBounds.extend(coord);
        }
      }
      return eventBounds;
    }

    function addEventCircle(event, coord) {
      var magnitude = parseFloat(event.magnitude);
      var radius = 0;
      var color = eventRadiusColors[0];
      for (var i = 0; i < eventRadii.length; i++) {
        if (magnitude >= eventRadii[i].from && magnitude <= eventRadii[i].to) {
          radius = eventRadii[i].radius;
          if (i < eventRadiusColors.length) {
            color = eventRadiusColors[i];
          }
        }
      }
      if (radius > 0) {
        options = {
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: color,
          fillOpacity: 0.35,
          map: map,
          center: coord,
          radius: radius,
          clickable: false
        };
        var circle = new google.maps.Circle(options);
      }
    }

    function timeToIndex(time) {
      if (timeRange.increment == 0) {
        // if only 1 event, use newest color
        return timeRange.count - 1;
      }
      else if (time <= timeRange.minimum) {
        return 0;
      }
      else if (time >= timeRange.maximum) {
        return timeRange.count - 1;
      }
      else {
        return Math.floor((time - timeRange.minimum) / timeRange.increment);
      }
    }

    function depthToIndex(depth) {
      if (depthRange.increment == 0) {
        // if only 1 event, use shallowest color
        return depthRange.count - 1;
      }
      else if (depth <= depthRange.minimum) {
        return depthRange.count - 1;
      }
      else if (depth >= depthRange.maximum) {
        return 0;
      }
      else {
        return depthRange.count - 1 - Math.floor((depth - depthRange.minimum) / depthRange.increment);
      }
    }

    function magnitudeToIndex(magnitude) {
      var index = magnitudeRange.base;
      if (magnitude >= magnitudeRange.maximum) {
        index += magnitudeRange.count - 1;
      }
      else if (magnitude > magnitudeRange.minimum) {
        index += Math.floor((magnitude - magnitudeRange.minimum) / magnitudeRange.increment);
      }
      return index;
    }

    function addEventMarker(markerOptions, event) {
      var marker = new google.maps.Marker(markerOptions);
      var id = event.id;
      eventMarkers[id] = marker;
      if (marker.getClickable()) {
        google.maps.event.addListener(marker, 'click', function () {
          showEarthquake(id, event.origin_id);
        });
      }
    }

    function showInfoWindow(id, marker, element) {
      infoWindow.contentId = id;
      infoWindow.setContent(element.cloneNode(true));
      infoWindow.open(map, marker);
    }

    function showEarthquake(id, origin_id) {
      var eventId = "event_" + id;
      if (infoWindow.contentId == eventId) {
        infoWindow.close();
        infoWindow.contentId = null;
      }
      else if (infoWindow.contentId == null && lines.length > 0 && eventLinesId == id) {
        eraseStationLines();
      }
      else {
        var locale = I18n.locale;
        var event_url = "/" + locale + "/origins/" + origin_id + "/info";
        $("#event_info").load(event_url, function () {
          showInfoWindow(eventId, eventMarkers[id], document.getElementById("event_info_" + id));
        });
        showStationLines(id);
      }
    }

    module.showEarthquake = showEarthquake;

    function setupStations(showInfoPopup) {
      var stationBounds = new google.maps.LatLngBounds();

      stationMarkerManager = new MarkerManager(map);

      var stationMarkers = [];
      var stationDotMarkers = [];
      for (var i = 0; i < stations.length; i++) {
        var station = stations[i];
        var labelledStation = createStation(station, true, showInfoPopup, stationBounds);
        stationMarkers.push(labelledStation);
        stationMarkersLabelled[station.id] = labelledStation;

        var unlabelledStation = createStation(station, false, showInfoPopup, stationBounds);
        stationDotMarkers.push(unlabelledStation);
        stationMarkersUnlabelled[station.id] = unlabelledStation;
      }
      google.maps.event.addListener(stationMarkerManager, 'loaded', function () {
        stationMarkerManager.addMarkers(stationDotMarkers, 0, LARGE_STATION_ZOOM_THRESHOLD);
        stationMarkerManager.addMarkers(stationMarkers, LARGE_STATION_ZOOM_THRESHOLD + 1);
        stationMarkerManager.refresh();
      });
      return stationBounds;
    }

    function createStation(station, withLabel, showInfoPopup, stationBounds) {
      var id = station.id;
      var coord = new google.maps.LatLng(station.latitude, station.longitude);
      var anchor = new google.maps.Point(16, 0);
      var marker;
      var markerOptions = {
        position: coord,
        title: station.station_code,
        clickable: showInfoPopup,
        zIndex: -1
      };
      if (withLabel) {
        markerOptions.icon = GMapUtil.generateMarkerImage(GMapUtil.imageStation(), 32);
        markerOptions.labelContent = station.station_code;
        markerOptions.labelAnchor = anchor;
        markerOptions.labelClass = "station_label";
        marker = new MarkerWithLabel(markerOptions);
      }
      else {
        markerOptions.icon = GMapUtil.generateMarkerImage(GMapUtil.imageStationDot(), 12);
        marker = new google.maps.Marker(markerOptions);
      }
      if (marker.getClickable()) {
        google.maps.event.addListener(marker, 'click', function () {
          module.showStation(id);
        });
      }
      stationBounds.extend(coord);
      return marker;
    }

    function setupFacilities(showInfoPopup) {
      for (var i = 0; i < facilityMarkerData.length; i++) {
        var facility = facilityMarkerData[i];
        facilityMarkers[facility.id] = createFacilityMarker(facility, showInfoPopup);
      }
    }

    function createFacilityMarker(facility, showInfoPopup) {
      var coord = new google.maps.LatLng(facility.latitude, facility.longitude);
      var marker;
      var markerOptions = {
        map: map,
        position: coord,
        title: I18n.t("globals.gmap.facility_icon_title") + facility.name,
        zIndex: FACILITY_Z_INDEX,
        clickable: showInfoPopup,
        icon: GMapUtil.generateMarkerImage(GMapUtil.imageFacility(facility.marker_image), 32)
      };
      marker = new google.maps.Marker(markerOptions);
      google.maps.event.addListener(marker, 'click', function () {
        module.showFacility(facility.id);
      });
      return marker;
    }

    function epicenterUrl(color, size, shape) {
      return "/epicenters/" + color + "/" + size + "/" + shape + ".png";
    }

    function beachballUrl(strike, dip, rake, size, color) {
      return ["/beachballs", strike.toFixed(0), dip.toFixed(0), rake.toFixed(0), size, color, "ffffffe6.png"].join("/");
    }

    function tag(name) {
      var content;
      var attributes;
      if (arguments.length == 3) {
        attributes = arguments[1];
        content = arguments[2];
      }
      else if (arguments.length == 2) {
        if (typeof(arguments[1]) == "string") {
          content = arguments[1];
        }
        else {
          attributes = arguments[1];
        }
      }
      var html = "<" + name;
      if (attributes) {
        for (var key in attributes) {
          html += " " + key + "='" + attributes[key] + "'";
        }
      }
      html += ">";
      if (content) {
        html += content;
      }
      if (tag != "img") {
        html += "</" + name + ">";
      }
      return html;
    }

    var td = tag.bind(undefined, "td");
    var tr = tag.bind(undefined, "tr");
    var img = tag.bind(undefined, "img");
    var p = tag.bind(undefined, "p");
    var table = tag.bind(undefined, "table");
    var div = tag.bind(undefined, "div");
    var h1 = tag.bind(undefined, "h1");

    var MINUTE = 60;
    var HOUR = 60 * MINUTE;
    var DAY = 24 * HOUR;
    var WEEK = 7 * DAY;
    var YEAR = 52 * WEEK;
    var INTERVALS = [
      [MINUTE, 1, "second_time_increment_html"],
      [HOUR, MINUTE, "minute_time_increment_html"],
      [DAY, HOUR, "hour_time_increment_html"],
      [WEEK, DAY, "day_time_increment_html"],
      [YEAR, WEEK, "week_time_increment_html"],
      [0, YEAR, "year_time_increment_html"]
    ];

    function timeRangeIncrement() {
      var interval = timeRange.increment;
      var period, name;
      for (var j = 0; j < INTERVALS.length; j++) {
        if (interval < INTERVALS[j][0] || INTERVALS[j][0] == 0) {
          period = INTERVALS[j][1];
          name = INTERVALS[j][2];
          break;
        }
      }
      // i18n-tasks-use t('globals.gmap.legend.second_time_increment_html')
      // i18n-tasks-use t('globals.gmap.legend.minute_time_increment_html')
      // i18n-tasks-use t('globals.gmap.legend.hour_time_increment_html')
      // i18n-tasks-use t('globals.gmap.legend.day_time_increment_html')
      // i18n-tasks-use t('globals.gmap.legend.week_time_increment_html')
      // i18n-tasks-use t('globals.gmap.legend.year_time_increment_html')
      return I18n.t("globals.gmap.legend." + name, {count: (1.0 * interval / period).toFixed(1)});
    }

    function timeRangeLabel(index) {
      var seconds = (1.0 * timeRange.increment * index + timeRange.minimum);
      var date = new Date(seconds * 1000);
      return Util.formatDate(seconds) + " " + Util.pad(date.getUTCHours()) + ":" + Util.pad(date.getUTCMinutes())
    }

    function timeRangeTooltip(index) {
      return I18n.t("globals.gmap.range", {from: timeRangeLabel(index), to: timeRangeLabel(index + 1)});
    }

    function depthRangeTooltip(index) {
      return I18n.t("globals.gmap.range", {from: depthRangeLabel(index), to: depthRangeLabel(index + 1)});
    }

    function depthRangeLabel(index) {
      var depth = 1.0 * depthRange.increment * (depthRange.count - 1 - index) + depthRange.minimum;
      if (window.useImperialUnits) {
        depth = Util.convertKilometresToMiles(depth);
      }
      return depth.toFixed(1) + (window.useImperialUnits ? " mi" : " km");
    }

    function magnitudeRangeTooltip(index) {
      return magnitudeRangeLabel(index) + " - " + magnitudeRangeLabel(index + 1);
    }

    function magnitudeRangeLabel(index) {
      return (1.0 * magnitudeRange.minimum + magnitudeRange.increment * index).toFixed(1);
    }

    var MAGNITUDE_CIRCLE_COLOR = "999999FF";
    var MAGNITUDE_CIRCLE_SIZE = 14;

    function createMagnitudeColorLegend() {
      var html = "";
      for (var i = magnitudeRange.count - 1; i >= 0; i--) {
        html +=
          tr({title: magnitudeRangeTooltip(i)},
            td(img({src: epicenterUrl(MARKER_COLORS[magnitudeRange.base + i], adjustedCircleSize(), CIRCLE_SHAPE)})) +
            td(magnitudeRangeLabel(i)));
      }
      if (hasNullMagnitudes) {
        html +=
          tr({title: I18n.t("globals.gmap.legend.null_magnitude_tooltip")},
            td(img({src: epicenterUrl(MARKER_COLOR_NULL, adjustedNullSize(), CIRCLE_SHAPE)})) +
            td(I18n.t("globals.gmap.legend.null_label")));
      }
      if (hasExternalEvents) {
        html +=
          tr({title: I18n.t("globals.gmap.legend.external_events_tooltip")},
            td(img({src: epicenterUrl(MAGNITUDE_CIRCLE_COLOR, adjustedCircleSize(), SQUARE_SHAPE)})) +
            td(I18n.t("globals.gmap.legend.external_events_label")));
      }
      return html;
    }

    function createMagnitudeSizeLegend() {
      var html = "";
      for (var i = magnitudeRange.count - 1; i >= 0; i--) {
        html +=
          tr({title: magnitudeRangeTooltip(i)},
            td({style: "text-align:center"},
              img({src: epicenterUrl(MAGNITUDE_CIRCLE_COLOR, adjustSizeWithMultiplier(ICON_SIZES[magnitudeRange.base + i]), CIRCLE_SHAPE)})) +
            td(magnitudeRangeLabel(i)));
      }
      if (hasNullMagnitudes) {
        html +=
          tr({title: I18n.t("globals.gmap.legend.null_magnitude_tooltip")},
            td(img({src: epicenterUrl(MAGNITUDE_CIRCLE_COLOR, adjustedNullSize(), CIRCLE_SHAPE)})) +
            td(I18n.t("globals.gmap.legend.null_label")));
      }
      if (hasExternalEvents) {
        html +=
          tr({title: I18n.t("globals.gmap.legend.external_events_tooltip")},
            td(img({src: epicenterUrl(MAGNITUDE_CIRCLE_COLOR, adjustedCircleSize(), SQUARE_SHAPE)})) +
            td(I18n.t("globals.gmap.legend.external_events_label")));
      }
      return html;
    }

    function createMagnitudeLegendBody() {
      if (getStrippedMarkerType() == module.MARKER_TYPES.MAGNITUDE) {
        return createMagnitudeColorLegend();
      }
      else {
        return createMagnitudeSizeLegend();
      }
    }

    function createMagnitudeLegend() {
      return h1(I18n.t("globals.gmap.legend.magnitude_legend_header")) + table(createMagnitudeLegendBody());
    }

    function createTimeLegendSpectrum() {
      var html = "";
      for (var i = timeRange.count - 1; i >= 0; i--) {
        html +=
          tr({title: timeRangeTooltip(i)},
            td({style: "background-color:#" + MARKER_COLORS[i].substring(0, 6) + ";padding: 0 4px;border: 0.5px solid #999"},
              div({"class": "spectrum_block"})) +
            td({style: "padding-left: 4px;"},
              i == 0 ? I18n.t("globals.gmap.legend.time_legend_oldest_label") : (i == timeRange.count - 1 ? I18n.t("globals.gmap.legend.time_legend_newest_label") : "")));
      }
      return html;
    }

    function createDepthLegendSpectrum() {
      var html = "";
      for (var i = depthRange.count - 1; i >= 0; i--) {
        html +=
          tr({title: depthRangeTooltip(i)},
            td({style: "background-color:#" + MARKER_COLORS[i].substring(0, 6) + ";padding: 0 4px;border: 0.5px solid #999"},
              div({"class": "spectrum_block"})) +
            td({style: "padding-left: 4px;"},
              depthRangeLabel(i)));
      }
      if (hasNullDepths) {
        html +=
          tr({title: I18n.t("globals.gmap.legend.null_depth_tooltip")},
            td({style: "background-color:#" + MARKER_COLOR_NULL.substring(0, 6) + ";padding: 0 4px;border: 0.5px solid #999"},
              div({"class": "spectrum_block"})) +
            td({style: "padding-left: 4px;"},
              I18n.t("globals.gmap.legend.null_label")));
      }
      return html;
    }

    function createTimeLegend() {
      if (timeRange.increment == 0) {
        return "";
      }
      return h1(I18n.t("globals.gmap.legend.time_legend_header")) +
        p(timeRangeIncrement()) +
        table({style: "margin-left:15px;"},
          createTimeLegendSpectrum());
    }

    function createDepthLegend() {
      if (depthRange.increment == 0) {
        return "";
      }
      return h1(I18n.t("globals.gmap.legend.depth_legend_header")) +
        table({style: "margin-left:15px;"},
          createDepthLegendSpectrum());
    }

    function createLegend() {
      switch (getStrippedMarkerType()) {
        case module.MARKER_TYPES.MAGNITUDE:
          return createMagnitudeLegend();
        case module.MARKER_TYPES.DATE_FIXED:
          return createTimeLegend();
        case module.MARKER_TYPES.DATE:
          return createMagnitudeLegend() + createTimeLegend();
        case module.MARKER_TYPES.DEPTH:
          return createMagnitudeLegend() + createDepthLegend();
      }

    }

    function LegendControl(legendDiv) {
      legendDiv.innerHTML = createLegend() +
        p({style: "margin-left:15px;margin-top:8px;"},
          img({src: GMapUtil.imageStationDot()}) + I18n.t("globals.gmap.legend.legend_station_label"));
      legendDiv.className = 'gmap_legend';
    }

    function eraseStationLines() {
      for (var i = 0; i < lines.length; i++) {
        lines[i].setMap(null);
      }
      lines = [];
      eventLinesId = null;
    }

    function drawStationLines(event, eventStations) {
      eraseStationLines();
      eventLinesId = event.id;
      var eventCoords = new google.maps.LatLng(event.latitude, event.longitude);
      for (var i = 0; i < eventStations.length; i++) {
        if (getStationMarker(eventStations[i].id)) {
          lines.push(createLine(eventCoords, eventStations[i]));
        }
      }
    }

    function getStationMarker(id) {
      if (map.getZoom() <= LARGE_STATION_ZOOM_THRESHOLD) {
        return stationMarkersUnlabelled[id];
      }
      else {
        return stationMarkersLabelled[id];
      }
    }

    function createLine(eventCoords, station) {
      var coords = [
        eventCoords,
        getStationMarker(station.id).getPosition()
      ];
      var line = new google.maps.Polyline({
        path: coords,
        strokeColor: "#0094ff",
        strokeOpacity: 0.5,
        strokeWeight: 2,
        geodesic: true,
        clickable: showStationInfo
      });
      if (showStationInfo) {
        google.maps.event.addListener(line, 'click', function () {
          module.showStation(station.id);
        });
      }
      line.setMap(map);
      return line;
    }

    function showStationLines(eventId) {
      if (stations.length == 0) {
        return;
      }
      if (singleEventWithMatchingStations) {
        drawStationLines(eventMarkerData[0], stations);
      }
      else if (showStationInfo && MapCookies.hasShowStationsSelected()) {
        $.getJSON("/events/" + eventId + "/stations.json", function (jsonObject) {
            for (var i = 0; i < eventMarkerData.length; i++) {
              if (eventMarkerData[i].id == eventId) {
                drawStationLines(eventMarkerData[i], jsonObject.data.stations);
                return;
              }
            }
          }
        );
      }
    }

    return module;
  };

  return GMap;
}));
